<ng-container *ngIf="_statusService.permissionsLoading$ | async; else appReady">
  <!-- use same full‑screen loader as login so the user sees consistent branding -->
  <div class="loader-container">
    <div class="loader-modern"></div>
    <p>Loading platform...</p>
  </div>
</ng-container>
<ng-template #appReady>
  <app-notifications></app-notifications>
  <router-outlet></router-outlet>
</ng-template>
